import { initNewsFilter } from './modules/news-filter';

document.addEventListener('DOMContentLoaded', () => {
  initNewsFilter();
});
